import AWS from './AWS';

import { Position, Region } from './Geo';

import User from './User';
import App from './App';
import MyApp from './MyApp';
import Endpoint from './Endpoint';
import MyEndpoint from './MyEndpoint';
import Config from './Config';
import MyLeases from './MyLeases';
import Review from './Review';

export default {
  AWS,
  Position,
  Region,
  User,
  App,
  MyApp,
  Endpoint,
  MyEndpoint,
  Config,
  MyLeases,
  Review,
};
